import Button from '@platform-ui-common/components/Button/index.js';
import TruncatedTextTooltip from '../TruncatedTextTooltip/index.js';

export interface DisplayEmailProps {
  email: string;
  mailTo?: boolean;
}

export default function DisplayEmail({ email, mailTo = true }: DisplayEmailProps): JSX.Element {
  return (
    <div className="flex gap-2 truncate">
      <TruncatedTextTooltip>{email}</TruncatedTextTooltip>
      {mailTo ? <Button icon="mail" external variant="text" link={`mailto:${email}`} /> : null}
    </div>
  );
}
